/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { computed } from '@ember/object';
import Component from '@glimmer/component';
import TemplateModel from 'cio/models/template';
import { EMPTY_BODY_METHODS } from 'cio/utils/composer/webhooks';
import ActionModel from 'cio/models/action';

interface PreviewerArgs {
  action: ActionModel;
  preview: Record<string, any>;
  template: TemplateModel;
  isRefreshing: boolean;
}

export default class Previewer extends Component<PreviewerArgs> {
  @computed('args.template.requestMethod')
  get isEmptyBodyMethod() {
    return EMPTY_BODY_METHODS.includes(this.args.template.requestMethod);
  }
}
